import { useMemo } from "react";
import {
  InputElementUnion,
  CommonInputSchemaValidator,
  resolveRequiredHiddenLabel,
} from "@graffer-inc/form-schema";
import { ErrorMessage } from "./helper";
import { ExternalLink, MarkdownEditor } from "@graffer-inc/console-design-kit";
import {
  markdownHelpLink,
  grafferSchemasSuportTagNames,
} from "../../../../../../utils/markdown/constants";

// this file is based on CommonPropertiesEditor of form-builder
// see: https://github.com/graffer-inc/graffer-schemas/blob/70784b3c071948bd221f8268b58112603a8d87fd/libs/packages/form-builder/lib/elements/editor-pane/element-editor/editors/common-properties-editor.tsx

type CommonPropertiesProps = {
  element: InputElementUnion;
  onElementUpdate: (arg: InputElementUnion) => void;
};

export const CommonPropertiesEditor: React.FC<CommonPropertiesProps> = ({
  element,
  onElementUpdate,
}) => {
  const schemaValidator = useMemo(() => {
    return new CommonInputSchemaValidator(element);
  }, [element]);

  const labelId = `${element.id}-label`;
  const descriptionId = `${element.id}-description`;

  return (
    <>
      <div className="field">
        <label className="label" htmlFor={labelId}>
          項目名
        </label>
        <div className="control">
          <p id={labelId}>{element.label.text}</p>
        </div>
      </div>
      <div className="field">
        <div className="label is-flex is-justify-content-space-between is-align-items-baseline mb-0">
          <label className="mb-2" htmlFor={descriptionId}>
            説明文
          </label>
          {element.description.isMarkdown && (
            <ExternalLink
              anchor={(props) => (
                <a
                  {...props}
                  href={markdownHelpLink}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  {props.children}
                </a>
              )}
            >
              入力方法やサンプルはこちら
            </ExternalLink>
          )}
        </div>
        <div className="control">
          {element.description.isMarkdown ? (
            <MarkdownEditor
              value={element.description.text}
              layout="standalone"
              allowedTagNames={grafferSchemasSuportTagNames}
              editAreaOptions={{
                attributes: {
                  id: descriptionId,
                  placeholder: "未設定",
                  rows: 5,
                },
              }}
              onChange={(text) => {
                onElementUpdate({
                  ...element,
                  description: {
                    ...element.description,
                    text: text,
                  },
                });
              }}
            />
          ) : (
            <textarea
              style={{ minHeight: "72px" }}
              id={descriptionId}
              className="input"
              rows={4}
              placeholder="未設定"
              value={element.description.text}
              onChange={(e) => {
                onElementUpdate({
                  ...element,
                  description: {
                    ...element.description,
                    text: e.target.value,
                  },
                });
              }}
            />
          )}
        </div>
        <ErrorMessage msg={schemaValidator.description()} />
      </div>
      <div className="field">
        <label className="label">必須・表示設定</label>
        <div className="control">
          <p>{resolveRequiredHiddenLabel(element)}</p>
        </div>
      </div>
    </>
  );
};
